/**
 * Quiz configuration — edit questions and outcomes here without touching component code.
 *
 * Decision tree:
 *   Q1 No  → Outcome A
 *   Q1 Yes → Q2 Yes → Outcome B
 *   Q1 Yes → Q2 No  → Q3 "One-off investment"  → Outcome C
 *   Q1 Yes → Q2 No  → Q3 "Ongoing cash flow gaps" → Outcome D
 */
import type { QuizConfig } from "./quiz-types";

export const quizConfig: QuizConfig = {
  questions: [
    {
      id: "q1",
      number: 1,
      prompt: "Have you been trading 6+ months with $5K+ monthly revenue?",
      options: [
        {
          id: "yes",
          label: "Yes",
          next: { type: "question", id: "q2" },
        },
        {
          id: "no",
          label: "No",
          next: { type: "outcome", id: "a" },
        },
      ],
    },
    {
      id: "q2",
      number: 2,
      prompt:
        "Do you have significant assets to pledge (real estate, equipment, inventory)?",
      options: [
        {
          id: "yes",
          label: "Yes",
          next: { type: "outcome", id: "b" },
        },
        {
          id: "no",
          label: "No",
          next: { type: "question", id: "q3" },
        },
      ],
    },
    {
      id: "q3",
      number: 3,
      prompt: "What do you need the capital for?",
      options: [
        {
          id: "one-off",
          label: "One-off investment",
          next: { type: "outcome", id: "c" },
        },
        {
          id: "ongoing",
          label: "Ongoing cash flow gaps",
          next: { type: "outcome", id: "d" },
        },
      ],
    },
  ],
  outcomes: {
    a: {
      id: "a",
      headline:
        "An SBA microloan or business credit card is likely your best fit.",
      subtitle:
        "You'll need more trading history before you qualify for most unsecured business loans, including Wayflyer's.",
      cta: {
        label: "Learn more about Wayflyer",
        href: "https://wayflyer.com",
        variant: "secondary",
      },
    },
    b: {
      id: "b",
      headline: "A secured loan will likely be cheaper.",
      subtitle:
        "If you have assets to pledge, secured financing typically offers lower rates than unsecured options.",
      cta: {
        label: "Apply for financing with Wayflyer",
        href: "https://app.wayflyer.com/authn/signup",
        variant: "primary",
      },
    },
    c: {
      id: "c",
      headline: "An unsecured term loan is a strong fit.",
      subtitle:
        "For one-off investments - inventory, marketing pushes, equipment - a fixed-term unsecured loan gives you predictable repayments.",
      cta: {
        label: "Apply for financing with Wayflyer",
        href: "https://app.wayflyer.com/authn/signup",
        variant: "primary",
      },
    },
    d: {
      id: "d",
      headline: "An unsecured line of credit is a strong fit.",
      subtitle:
        "For ongoing cash flow gaps, a line of credit lets you draw what you need, when you need it.",
      cta: {
        label: "Apply for financing with Wayflyer",
        href: "https://app.wayflyer.com/authn/signup",
        variant: "primary",
      },
    },
  },
};
